import { setShowSensitiveOnLocal } from '~/app/_hooks/use-show-sensitive';
import { user_preference_sensitive as UserPreferenceSensitive } from '~/infra/api/rpc';
import { updateUserPreferenceSensitive } from '@app/_repositories/mutation-service';
import type { UpdateUserPreferenceSensitiveRequest } from '@app/_repositories/mutation-service';

export const updateShowSensitive = async (showSensitive: boolean) => {
  const request: UpdateUserPreferenceSensitiveRequest = {
    show_sensitive: showSensitive
      ? UserPreferenceSensitive.ShowSensitive.SHOW_SENSITIVE_NOT_BLOCK_AND_LIST
      : UserPreferenceSensitive.ShowSensitive.SHOW_SENSITIVE_BLOCK_AND_NOT_LIST,
  };

  await updateUserPreferenceSensitive(request);
  setShowSensitiveOnLocal(showSensitive);
};
